var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rexer-event_dropdown",
      class: [_vm.open ? "open" : ""],
      on: {
        click: function($event) {
          return _vm.toggleDropdown()
        }
      }
    },
    [
      _c("span", [_vm._v("\n    " + _vm._s(_vm.selection) + "\n  ")]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "rexer-event_dropdown-content",
          on: {
            mouseleave: function($event) {
              _vm.open = false
            }
          }
        },
        _vm._l(_vm.locations, function(item, index) {
          return _c(
            "a",
            {
              key: index,
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.selectionHandle(item)
                }
              }
            },
            [_vm._v("\n      " + _vm._s(item.label) + "\n    ")]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }